import { z } from '@repo/schema'
import type { ResponseError } from '@repo/upfetch'

const ApiErrorCodeSchema = z.object({ code: z.string().min(1) })

/**
 * Read the machine-readable `code` an API refusal may carry next to its message,
 * for example `customer_has_no_vat` on a 422. Returns undefined when there is none.
 */
export function getApiErrorCode(error: ResponseError): string | undefined {
  return ApiErrorCodeSchema.safeParse(error.data).data?.code
}
